export default __webpack_public_path__ + "static/media/Icon_1.52e42a34.svg";